import { trackLinkClick } from 'utils/tracking';
import CheckIcon from '@/components/ui/icons/CheckIcon';
import Links from '@/components/ui/Links';
import { Page_Pagebuilder_Blocks_Checklist } from '@/graphql/generated/graphql';
import { m } from 'motion/react';
import { containerVariants, itemVariants, viewPort } from 'utils/framer';
import { getContainerClass } from 'utils/helpers';
import Wysiwyg from '../components/dom-parser';

const ChecklistBlock = ({
  blockId,
  list,
  links,
  iconPosition,
  containerWidth,
}: Page_Pagebuilder_Blocks_Checklist) => {
  if (!list || (list && list.length < 1)) return null;
  return (
    <section
      id={blockId ?? undefined}
      className="w-full my-14 lg:my-24 px-4 md:px-0"
    >
      <div
        className={`w-full ${getContainerClass(containerWidth)} ${iconPosition === 'left' ? '' : 'text-center -mt-2 lg:-mt-4'}`}
      >
        <m.ul
          initial="hidden"
          whileInView="visible"
          viewport={viewPort}
          variants={containerVariants}
          className="flex flex-col lg:flex-row gap-8"
        >
          {list.map((item, i) => (
            <m.li
              initial="hidden"
              whileInView="visible"
              viewport={viewPort}
              variants={itemVariants}
              key={i}
              className={`editor-checklist w-full flex ${iconPosition === 'left' ? 'flex-row items-start gap-2 lg:gap-3' : 'flex-col items-center gap-2 lg:gap-3'}`}
            >
              <CheckIcon className="w-5 min-w-5 h-5 mt-0.5" />
              <Wysiwyg>{item.text}</Wysiwyg>
            </m.li>
          ))}
        </m.ul>
        <Links links={links} onLinkClick={trackLinkClick} />
      </div>
    </section>
  );
};

export default ChecklistBlock;
